import view from "../../views/error.js";
import { router } from "../router/index.routes";

let error = {
    render: () => {
        
        return view;
    },
    after_render: async () => {
        
    },
    root: true, 
    rerender: true,
    
};

export default error;